module.exports = __webpack_public_path__ + "img/tarjeta_beneficios_tallerCRM.6aecc6cd.jpg";